export * from './advertisement';
export * from './advertisement-list';


// WEBPACK FOOTER //
// D:/bs_work/toMigrate_litePortal/src/app/models/mygolf/advertisement/index.ts